import { $ } from 'src/shared/js/utils/dom';

const videoButton = $('.start-header__button');
const video = $('.start-header__media-video');

if (video) {
  const playPauseVideo = () => {
    if (video.paused) {
      playVideo();
    } else {
      pauseVideo();
    }
  };

  const playVideo = () => {
    video.play();
    videoButton.classList.remove('paused');
  };

  const pauseVideo = () => {
    video.pause();
    videoButton.classList.add('paused');
  };

  videoButton.addEventListener('click', playPauseVideo);
}
